import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './header';
import { Footer } from './footer';
import { Flex, useDisclosure } from '@chakra-ui/react';
import { LeftDrawer } from './LeftDrawer';

export const RootLayoutWithTopHeader = (): JSX.Element => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <Flex height="100%" flexDirection="column">
      <Header onOpen={onOpen} />

      <LeftDrawer onClose={onClose} isOpen={isOpen} />

      <Flex as="main" flex={1}>
        <Outlet />
      </Flex>

      <Footer />
    </Flex>
  );
};
